import styled, { css, keyframes } from 'styled-components';

export const Flex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const media = {
  desktop: (...args) => css`
    @media (max-width: 5000px) {
      ${css(...args)};
    }
  `,
  w1440: (...args) => css`
    @media (max-width: 1440px) {
      ${css(...args)};
    }
  `,
  w1200: (...args) => css`
    @media (max-width: 1200px) {
      ${css(...args)};
    }
  `,
  tablet: (...args) => css`
    @media (max-width: 1024px) {
      ${css(...args)};
    }
  `,
  w800: (...args) => css`
    @media (max-width: 800px) {
      ${css(...args)};
    }
  `,
  mobile: (...args) => css`
    @media (max-width: 600px) {
      ${css(...args)};
    }
  `,
  iphone67p: (...args) => css`
    @media (max-width: 414px) {
      ${css(...args)};
    }
  `,
  iphone67: (...args) => css`
    @media (max-width: 375px) {
      ${css(...args)};
    }
  `,
  se: (...args) => css`
    @media (max-width: 320px) {
      ${css(...args)};
    }
  `
};

export const transitions = {
  slideDown: keyframes`
    0% {
      opacity: 0;
      transform: translateY(-100%);
    }
    75% {
      opacity: 1;
    }
    100% {
      transform: translateY(100%);
    }
  `,
  slideUp: keyframes`
    0% {
      transform: translateY(100%);
      opacity: 1;
    }
    25% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(-100%);
    }
  `,
  stretchOut: keyframes`
    0% {
      opacity: 0;
      transform: scale(0.25,0.25);
    }
    100% {
      opacity: 1;
      transform: scale(1, 1);
    }
  `,
  shrinkIn: keyframes`
    0% {
      opacity: 1;
      transform: scale(1,1);
    }
    100% {
      opacity: 0;
      transform: scale(0.25,0.25);
    }
  `
};



// WEBPACK FOOTER //
// ./src/lib/style-utils.js